// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"141":"booking-create","466":"booking-detail","805":"booking-list"}[chunkId] || chunkId) + "." + {"141":"ba6f93ce","256":"09b6cae2","466":"1fb65d51","805":"7fcc9101"}[chunkId] + ".js";
};